import React, { Suspense } from 'react';
import { Outlet } from "react-router-dom";

import Header from './Header'
import Loading from './Loading'

export default function Layout({} ) {
    return (
        <>
            <Header />
            <Suspense fallback={<Loading />}>
                <Outlet />
            </Suspense>
        </>
    )
};


